import { Button, Card, Stack, SvgIcon, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import {
  getFormIdForScreeningAction,
  getScreening,
  previewScreeningFormAction,
} from 'src/redux/actions/patientScreening';
import ListingTable from 'src/sections/dashboard/patients/patient-details-listing-table';
import { paths } from 'src/paths';
import { Permissions, useScopeChecker } from 'src/rbac';
import Plus from '@untitled-ui/icons-react/build/esm/Plus';
import loader from 'src/components/LoaderImg/loader.gif';
import { Box } from '@mui/system';

const PatientScreening = () => {
  const [rowPerPage, setRowPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const screeningData = useSelector((state: any) => state?.getScreeningReducer?.response);
  const screeningDataLoader = useSelector((state: any) => state.getScreeningReducer?.loader);
  const has = useScopeChecker();
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getPatientId = useSelector((state: any) => state?.getPatientIdReducer);
  const formIdOfScreening = useSelector((state: any) => state.getFormIdForScreeningReducer);

  useEffect(() => {
    if (!!getPatientId) {
      dispatch(getScreening({ patientId: getPatientId }));
      dispatch(
        getFormIdForScreeningAction({
          patientId: getPatientId,
        })
      );
    }
  }, [getPatientId]);

  const onRowClick = (data: any) => {
    dispatch(previewScreeningFormAction(data));
    navigate('/patients/patient-details/screening/view-document');
  };

  const handleAddScreening = () => {
    if (!!formIdOfScreening?.response)
      navigate('/patients/patient-details/screening/view-form', {
        state: {
          document: {
            formId: formIdOfScreening?.response,
          },
        },
      });
  };

  return (
    <Card>
      <Stack>
        <Stack
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'space-between'}
          p={3}
        >
          <Stack
            gap="1rem"
            alignItems="center"
            flexDirection="row"
          >
            <h3 style={{ margin: '0px' }}>Screenings</h3>
            <Stack
              flexDirection="row"
              sx={{
                borderRadius: '12px',
                display: 'flex',
                border: '1px solid #00000042',
                color: '#111927',
                padding: '3px 10px',
              }}
            >
              <Typography variant="subtitle2">{`${screeningData?.totalElements} Screenings`}</Typography>
            </Stack>
          </Stack>
          {patientData?.active && (
            <Stack>
              <Button
                color="inherit"
                startIcon={
                  <SvgIcon>
                    <Plus />
                  </SvgIcon>
                }
                disabled={!has(Permissions.CREATE_SCREENING)}
                onClick={handleAddScreening}
                sx={{ color: 'primary.dark' }}
              >
                Add New Screening
              </Button>
            </Stack>
          )}
        </Stack>
        {screeningDataLoader ? (
          <Box sx={{ height: 300, margin: 'auto', width: '10%', marginTop: '100px' }}>
            <img
              src={loader}
              alt="loader"
              // style={{ width: '10%', margin: 'auto' }}
            />
          </Box>
        ) : screeningData?.totalElements > 0 ? (
          <ListingTable
            items={screeningData?.content || []}
            count={screeningData?.totalElements}
            page={page}
            rowsPerPage={rowPerPage}
            onRowClick={onRowClick}
            tableHead={[
              {
                label: 'SCREENING TYPE',
                value: 'screeningType',
              },
              {
                label: 'EVAL DISCIPLINE',
                value: 'evalDiscipline',
              },
              {
                label: 'Screening Completion Date ',
                value: 'dischargeDate',
              },
              {
                label: 'Status',
                value: 'active',
              },
              {
                label: '',
                value: 'arrow',
              },
            ]}
          />
        ) : (
          <Typography
            variant="body1"
            sx={{ margin: '1rem auto' }}
          >
            No Records Found
          </Typography>
        )}
      </Stack>
    </Card>
  );
};

export default PatientScreening;
